(() => {
  const link = document.querySelector('[data-whatsapp-float]');
  if (!link) return;
  const mobile = matchMedia('(max-width:700px)');
  let queued = false;
  const visible = element => {
    if (!element || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    const rect = element.getBoundingClientRect();
    return rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  };
  const update = () => {
    queued = false;
    const overlay = [...document.querySelectorAll('[data-panel]:not([hidden]),dialog[open],[role="dialog"][aria-modal="true"],.filters.open,.shopify-pc__banner,#shopify-pc__banner,[data-cookie-banner]')].some(visible);
    const editing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
    const purchase = mobile.matches && visible(document.querySelector('.purchase'));
    const footer = !document.body.classList.contains('mobai-finder-page') && visible(document.querySelector('footer'));
    const contact = mobile.matches && visible(document.querySelector('#mobai-contact-form'));
    const hide = Boolean(overlay || editing || purchase || footer || contact);
    if (link.hidden !== hide) link.hidden = hide;
  };
  const schedule = () => {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  };
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  new MutationObserver(schedule).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden','open','class','style','aria-hidden','aria-modal'] });
  update();
})();
